<div class="flex justify-center items-center h-screen">
  <img src="../../../../assets/images/Blocks@1x-0.8s-200px-200px.svg" alt="loading">
</div>
